import { useAtom, useSetAtom } from "jotai";
import { baseAtom } from "../../../stores/jotai/base";
import { categoryAtom } from "../../../stores/jotai/categories/categories";
import { discoverySessionAtom, setSessionByGroupID } from "../../../stores/jotai/discovery-session";
import { v3MigrationAtom } from "../../../stores/jotai/migration/v3MigrationAtom";

const useSwitchTeam = () => {
	const [base, setBase] = useAtom(baseAtom);
	const [discoverySession, setDiscoverySession] = useAtom(discoverySessionAtom);
	const setCategoryState = useSetAtom(categoryAtom);
	const setV3MigrationAtomState = useSetAtom(v3MigrationAtom);
    const currentTeamID = base?.team?.groupID;

	const switchTeam = (teamID, statesWithPreviousValuesToHold = {}) => {
		if (teamID !== currentTeamID) {
			setSessionByGroupID({
                setBase,
                setCategoryState,
                set: setDiscoverySession,
                existing: discoverySession,
                groupID: teamID,
                statesWithPreviousValuesToHold,
                setV3MigrationAtomState,
            });
		}
	};

	return { switchTeam };
};

export default useSwitchTeam;
